interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];

    sourceId: string;
    spuIds: string;
}

export const pageParams: PageParams = {
    pathname: 'delta-pro-ultra-x',
    generalKeys: ['product_ps_delta_dprs'],
    // generalKeys: ['product_home_yj751'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'black',
    sites: ['us', 'ca'],

    sourceId: 'delta-pro-ultra-x',
    spuIds: '1888787816089489409',
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
